enum RecommendationApiWarning {
  LIMIT_FOR_USER_REACHED = 'E400_RECOMMENDATION_RULE_LIMIT_FROM_USER_REACHED',
  TIME_LIMIT_FOR_USER_2_USER_REACHED = 'E400_RECOMMENDATION_RULE_LIMIT_FOR_USER_FROM_USER_WITHIN_TIMELIMIT_REACHED',
  PROJECTPREFERENCES_DO_NOT_MATCH = 'E400_RECOMMENDATION_RULE_PROJECT_PREFERENCES_NOT_MATCHING',
  RECOMMENDATION_ALREADY_EXISTS = 'E400_RECOMMENDATION_RULE_RECOMMENDATION_ALREADY_EXISTS',
  RECOMMENDING_IS_CREATOR = 'E400_RECOMMENDATION_RULE_RECOMMENDING_USER_IS_PROJECT_CREATOR',
  USER_BLOCKED = 'E400_RECOMMENDATION_RULE_RECOMMENDATION_FOR_USER_FROM_USER_BLOCKED',
  RECOMMENDED_IS_CREATOR = 'E400_RECOMMENDATION_RULE_RECOMMENDED_USER_IS_PROJECT_CREATOR',
  PROJECT_ALREADY_VIEWED = 'E400_RECOMMENDATION_RULE_PROJECT_ALREADY_VIEWED',
  PROJECT_ALREADY_NOTIFIED_BY_TAG = 'E400_RECOMMENDATION_RULE_PROJECT_ALREADY_NOTIFIED_BY_TAG'
}

export default RecommendationApiWarning;
